import React, {useState} from "react";
import credit from "../assets/credit-card.svg";
import chart1 from "../assets/chart.png";
import chart2 from "../assets/chart2.png";
import chart3 from "../assets/chart3.png";
import LineChart from "../../../GlobalComponents/LineChart/LineChart";
const WaveSection = () => {
  const Card = ({ amount, title, chart, dates }) => {
    return (
      <div className="card h-[231px]">
        <div className="mdb-[14px] pt-[24px] pl-[24px]">
          <div className="mb-[10px] flex h-[42px] w-[42px] items-center justify-center rounded-full bg-[#28C76F]/[.08] ">
            <img src={credit} alt="credit" />
          </div>
          <div>
            <h4 className="text-res-ls font-semibold md:leading-[24px]">
              {amount}
            </h4>
            <p className="text-[13px] leading-[20px]">{title}</p>
          </div>
        </div>
        <div>
          {/* <img src={chart} className="max-h-[97px] w-full" alt="chart" /> */}
          <div className="w-full">
            <LineChart dates={dates}></LineChart>
          </div>
        </div>
      </div>
    );
  };
  const basic1 = [
    { title: "Total Shares", amount: "300" },
    { title: "Total Payout", amount: "$25,489.43" },
    { title: "Today’s Estimated Payout", amount: "$254.37" },
  ];
  const basic2 = [
    { title: "Your Shares", amount: "75" },
    { title: "Your % Share", amount: "4%" },
    { title: "Today’s Payout", amount: "$675.54" },
  ];
  const BasicInfoLayout = ({ info }) => {
    return (
      <div className="mt-[10px] flex flex-wrap gap-[10px]">
        {info.map((single, i) => (
          <div
            key={i}
            className="card min-w-[202px] grow pt-[18px] pb-[23px] text-center"
          >
            <h2 className="text-res-xs mb-[8px] font-semibold text-main-green">
              {single.title}
            </h2>
            <p className="text-normal font-bold md:text-[30px] md:leading-[36px]">
              {single.amount}
            </p>
          </div>
        ))}
      </div>
    );
  };
  const dates1 = [
    ["2023-06-01", 100],
    ["2023-06-02", 200],
    ["2023-06-03", 150],
    ["2023-06-04", 300],
    ["2023-06-05", 150],
    ["2023-06-06", 300],
    ["2023-06-07", 250],
  ];
  const dates2 = [
    ["2023-06-01", 250],
    ["2023-06-02", 100],
    ["2023-06-03", 200],
    ["2023-06-04", 300],
    ["2023-06-05", 180],
    ["2023-06-06", 50],
    ["2023-06-07", 200],
    ["2023-06-08 ", 250],
  ];
  const dates3 = [
    ["2023-06-01", 60],
    ["2023-06-02", 100],
    ["2023-06-03", 200],
    ["2023-06-04", 150],
    ["2023-06-05", 300],
    ["2023-06-06", 250],
  ];

  return (
    <div>
      <div className="all-reward-cards-wrap grid grid-cols-1 gap-[10px] md:grid-cols-3">
        <div>
          <Card
            amount={"1,000"}
            title={"Total Users"}
            chart={chart1}
            dates={dates1}
          ></Card>
          <BasicInfoLayout info={basic1}></BasicInfoLayout>
        </div>
        <div>
          <Card
            amount={"15,394"}
            title={"Average Payout per Share"}
            dates={dates2}
          ></Card>
          <div className="bg-custom-gradient mt-[10px] min-h-[220px]  w-full rounded-[10px] px-2 pt-[50px] pb-[45px] text-center">
            <h2 className="text-res-xs mb-[7px] font-bold text-main-black">
              Unclaimed Rewards
            </h2>
            <p className="text-res-lg mb-[11px] font-bold text-main-black">
              $173.57
            </p>
            <div>
              <button className="reward-button-shadow h-[40px] w-[150px] rounded-[6px] bg-main-black font-bold ">
                Claim
              </button>
            </div>
          </div>
        </div>
        <div>
          <Card
            amount={"$162,398.45"}
            title={"Total Revenue"}
            dates={dates3}
          ></Card>
          <BasicInfoLayout info={basic2}></BasicInfoLayout>
        </div>
      </div>
    </div>
  );
};

export default WaveSection;
